import { Allowance, description} from "../zugferd_2_3_2/allowance"
export { Allowance, description }